
const state = {
  poSelectedList: []
}

const getters = {
  getPoSelectedList (state) {
    return state.poSelectedList
  }
}

const actions = {
  'PUSH_PO_SELECTED': ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('mutationPushPo', payload)
    })
  },
}

const mutations = {
  mutationPushPo (state, payload) {
    if (payload.type == 'add') {
      payload.data.forEach(e => {
        if (!(state.poSelectedList.filter(o => o.ItemPK == e.ItemPK).length > 0)) {
          state.poSelectedList.push(e)
        }
      })
    } else if (payload.type == 'delete') {
      let index = state.poSelectedList.findIndex(o => o.ItemPK == payload.itemPK)
      state.poSelectedList.splice(index, 1)
    } else if (payload.type == 'clear') {
      state.poSelectedList = []
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
